import React from "react";
import { Box } from "@mui/material";

// import GraphicalSkeleton from "src/components/pages/dashboard/skeleton/dashboard/GraphicalChart";
// import { UseDashboardContext } from "src/context/dashboard";
import Header from "./Header";
import Graph from "./Graph";
import useStyles from "./Styles";

const GraphicalChart: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box id="tour-dashboard-graphical-chart" className={classes.gridItems}>
      <Header />
      <Graph />
    </Box>
  );
};

export default GraphicalChart;
